import React from "react";

const Textarea = React.lazy(() => import("./elements/Textarea"));
const WelcomeSection = React.lazy(() => import("./elements/homePage/WelcomeSection"));
const Attractions = React.lazy(() => import("./elements/attractionsSection/Attractions"));
const News = React.lazy(() => import("./elements/newsSection/News"));
const Reports = React.lazy(() => import("./elements/reportsSection/Reports"));
const Career = React.lazy(() => import("./elements/careerSection/Career"));
const ActivitiesSection = React.lazy(() => import("./elements/homePage/ActivitiesSection"));
const OurPartners = React.lazy(() => import("./elements/ourPartnerSection/OurPartners"));
const ImageWithContent = React.lazy(() => import("./elements/ImageWithContent"));
const OnlyTitle = React.lazy(() => import("./elements/OnlyTitle"));
const DocumentSection = React.lazy(() => import("./elements/DocumentSection"));
const Faqs = React.lazy(() => import("./elements/faqSection/Faqs"));
const PhotoAlbum = React.lazy(() => import("./elements/PhotoAlbum/PhotoAlbum"));
const ImageWithBlock = React.lazy(() => import("./elements/ImageWithBlock"));
const Discounts = React.lazy(() => import("./elements/Discounts"));
const TheTeam = React.lazy(() => import("./elements/theTeamSection/TheTeam"));
const GalleryContent = React.lazy(() => import("./elements/GalleryContent"));
import PartnersInformation from './elements/PatnersInformation';

function Components({ PageData, alias,ContactInfo,Constant }) {

    const Components = PageData?.txtDescription ? JSON.parse(PageData.txtDescription) : [];
    const Html = Components?.map((value, index) => {
        switch (value.type) {
            case 'about_block':
                return <WelcomeSection content={value} key={index} />;
            case 'attractions_template':
                return <Attractions content={value} ContactInfo={ContactInfo} alias={alias} PageData={PageData} Constant={Constant} key={index} />;
            case 'news_template':
                return <News content={value} key={index} Constant={Constant}/>;
            case 'activities_section':
                return <ActivitiesSection content={value} ContactInfo={ContactInfo} alias={alias} PageData={PageData} Constant={Constant} key={index} />;
            case 'ourpartners_template':
                return <OurPartners content={value} key={index} Constant={Constant} />;
            case 'team_template':
                return <TheTeam content={value} key={index} Constant={Constant} />;
            case 'faq_template':
                return <Faqs content={value} key={index} Constant={Constant} />;
            case 'textarea':
                return <Textarea content={value} key={index} />;
            case 'only_title':
                return <OnlyTitle content={value} key={index} />;
            case 'image_content':
                return <ImageWithContent content={value} key={index} />;
            case 'img_content':
                return <ImageWithBlock content={value} key={index} />;
            case 'partners-information-section':
                return <PartnersInformation content={value} key={index} />;
            case 'tab-with-discounts-section':
                return <Discounts content={value} key={index} />;
            case 'document':
                return <DocumentSection content={value} ContactInfo={ContactInfo} alias={alias} PageData={PageData} Constant={Constant} key={index} />;
            case 'photoalbum_template':
                return <PhotoAlbum content={value} ContactInfo={ContactInfo} alias={alias} PageData={PageData} Constant={Constant} key={index} />;
            case 'report-block':
                return <Reports content={value} key={index} />;
            case 'career-block':
                return <Career content={value} key={index} />;
            case 'gallery_carousel':
                return <GalleryContent content={value} key={index} />;
            default:
                break;
        }
    });

    return (
        <>

            {Html}

        </>
    )

}

export default Components;